import { useMediaQuery as p } from "@react-hookz/web";
import { u as m } from "./window-BSUR27FD.mjs";
import { t as o } from "./breakpoints-DvaoDEis.mjs";
import { r as d } from "./index-DRvG3Okc.mjs";
const i = (e, t) => p(d(e), t), h = (e, t = !1, a) => {
  const s = i(e, {
    initializeWithValue: !1,
    ...a
  });
  return s ?? t;
}, y = () => {
  var e;
  const t = i(o.breakpoints.up("largeDesktop"), {
    initializeWithValue: !1
  }), a = i(o.breakpoints.only("mediumDesktop"), {
    initializeWithValue: !1
  }), s = i(o.breakpoints.between("desktop", "mediumDesktop"), {
    initializeWithValue: !1
  }), l = i(o.breakpoints.only("tablet"), {
    initializeWithValue: !1
  }), r = i(o.breakpoints.only("mobile"), {
    initializeWithValue: !1
  });
  if (m()) return "mobile";
  const n = {
    desktop: s,
    largeDesktopUp: t,
    mediumDesktop: a,
    mobile: r,
    tablet: l
  };
  return (e = Object.keys(n).find((u) => n[u])) !== null && e !== void 0 ? e : "mobile";
};
export {
  y as a,
  h as u
};
//# sourceMappingURL=hooks-B5MFtECi.mjs.map
